import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { CaseManagementStore } from "Store";

export default class Suggestion extends Component {
  constructor(props) {
    super(props);
    this.state = { showTemplate: true, hideTemplate: false };
    this.showTemplate = this.showTemplate.bind(this);
  }
  static propTypes = {
    id: PropTypes.number,
    index: PropTypes.number,
    contentList: PropTypes.array,
    onConfirm: PropTypes.func
  };

  showTemplate() {
    this.setState({
      showTemplate: !this.state.showTemplate,
      hideTemplate: !this.state.hideTemplate
    });
  }

  render() {
    const { contentList, textTypingSplit } = this.props;
    const { showTemplate, hideTemplate } = this.state;
    const viewTemplate = contentList.map((template, index) => {
      return (
        <TemplateReplySuggest
          key={index}
          onClick={this.onAddTemplate.bind(this, template)}
        >
          <SuggestWord>
            {template.content.split("\n").map((item, key) => {
              return (
                <span key={key}>
                  {item.length > 200 ? `${item.substring(0, 100)} ...` : item}
                </span>
              );
            })}
          </SuggestWord>
        </TemplateReplySuggest>
      );
    });
    if (textTypingSplit === "" && hideTemplate) {
      this.showTemplate();
    }
    if (!showTemplate) {
      return "";
    } else {
      return <TemplateReplyWrapper>{viewTemplate}</TemplateReplyWrapper>;
    }
  }
  suggestWord = template => {
    if (template.content.length > 30) {
      let contentNew = template.content.slice(0, 30) + "...";
      <SuggestWord>
        {contentNew.split("\n").map((item, key) => {
          return <span key={key}>{item}</span>;
        })}
      </SuggestWord>;
    } else {
      <SuggestWord>
        {template.content.split("\n").map((item, key) => {
          return <span key={key}>{item}</span>;
        })}
      </SuggestWord>;
    }
  };
  onAddTemplate = template => {
    const { contentList, onConfirm, textTypingSplit } = this.props;
    contentList.map(items => {
      if (items.content == template.content) {
        let splitText = CaseManagementStore.message.split(" ");
        splitText[splitText.length - 1] = "";
        let joinText = splitText.join(" ");
        CaseManagementStore.message = joinText;
        CaseManagementStore.message =
          CaseManagementStore.message + " " + items.content;
      }
    });
    this.showTemplate();
  };
}

const TemplateReplySuggest = styled.div`
  min-height: 20px;
  border-radius: 20px;
  border: 1px solid #a5a5a5;
  margin: 0px 3px 0px 3px;
  padding: 5px 10px 5px 10px;
  background: white;
  justify-content: center;
  align-content: center;
`;

const SuggestWord = styled.span``;
const Wrapper = styled.div``;

const TemplateReplyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 6px;
  background-color: transparent;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/SuggestionWithMutation.js